import { render, staticRenderFns } from "./PartnerView.vue?vue&type=template&id=5648d458&"
import script from "./PartnerView.vue?vue&type=script&lang=js&"
export * from "./PartnerView.vue?vue&type=script&lang=js&"
import style0 from "./PartnerView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports